import FabricanteService from "@/services/FabricanteService"

export const actions = {
    cadastrarFabricante: ({commit, dispatch}) => {
        commit('setFabricante', {
            nome: "",
        }),
        dispatch('setModalCadastroFabricante', true)
    },
    listarFabricantes: ({commit}, data) => {
        commit('setOverlay', true)
        FabricanteService.listar(data)
        .then(res => {
            commit('setOverlay', false)
            commit('setFabricantes', res.data)
        })
        .catch(e => {
            commit('setOverlay', false)
            console.log(e)
        })
    },
    visualizarFabricante: ({commit, dispatch}, data) => {
        commit('setFabricante', data)
        dispatch('setModalCadastroFabricante', true)
    },
    salvarFabricante: ({commit, dispatch}, data) => {
        commit('setOverlay', true)
        FabricanteService.salvar(data)
        .then(res => {
            commit('addFabricante', res.data)
            commit('setFabricante', res.data)
            commit('setOverlay', false)
            commit('snackbarSuccess', 'Fabricante cadastrado.')
            dispatch('setModalCadastroFabricante', false)
        })
        .catch(e => {
            if(e.response.status == 422){
                commit('alertError', e.response.data.errors)
            }
            console.log(e)
            commit('setOverlay', false)
            commit('snackbarError', 'Erro ao cadastrar.')
        })
    },
    atualizarFabricante: ({commit, dispatch}, data) => {
        commit('setOverlay', true)
        FabricanteService.atualizar(data)
        .then(res => {
            commit('setOverlay', false)
            commit('snackbarInfo', 'Fabricante atualizado.')
        })
        .catch(e => {
            if(e.response.status == 422){
                commit('alertError', e.response.data.errors)
            }
            console.log(e)
            commit('setOverlay', false)
            commit('snackbarError', 'Erro ao atualizar.')
        })
    },
    excluirFabricante: ({commit, dispatch}, data) => {
        commit('setOverlay', true)
        dispatch('setModalExcluirFabricante', false)
        dispatch('setModalCadastroFabricante', false)
        FabricanteService.excluir(data.id)
        .then(res => {
            commit('removeFabricante', data)
            commit('setOverlay', false)
            commit('snackbarError', 'Fabricante excluído.')
        })
        .catch(e => {
            console.log(e)
            commit('setOverlay', false)
            commit('snackbarError', 'Erro ao excluir Fabricante.')
        })
    },
    setModalCadastroFabricante: ({commit}, status) => {
        commit('setModalCadastrarFabricante', false)
        setTimeout(() => {
            commit('setModalCadastrarFabricante', status)
        }, 100);
    },
    setModalExcluirFabricante: ({commit}, status) => {
        commit('setModalExcluirFabricante', false)
        setTimeout(() => {
            commit('setModalExcluirFabricante', status)
        }, 100);
    },
}

export default {}